export default "__VITE_ASSET__DxsUSl4o__"